const carBrandKeys = {
  all: ['car-brand'],
  list: () => [...carBrandKeys.all, 'list'],
}

const carModelKeys = {
  all: ['car-model'],
  list: (brandId: number) => [...carModelKeys.all, brandId],
}

const carDetailModelKeys = {
  all: ['car-detail-model'],
  list: (brandId: number, carId: number) => [
    ...carDetailModelKeys.all,
    brandId,
    carId,
  ],
}

const vehicleOptionsKeys = {
  all: ['vehicle-options'],
  detail: ({
    standardId,
    fuelType,
  }: {
    standardId?: number | null
    fuelType?: string | null
  }) => [...vehicleOptionsKeys.all, standardId, fuelType],
}

const macarKeys = {
  all: ['macar'],
  /** 내 차량 목록 */
  list: () => [...macarKeys.all, 'list'],
  detail: (macarId?: number) => [...macarKeys.all, 'detail', macarId],
}

export const CAR_QUERY_KEYS = {
  CAR_BRAND: carBrandKeys,
  CAR_MODEL: carModelKeys,
  CAR_DETAIL_MODEL: carDetailModelKeys,
  VEHICLE_OPTIONS: vehicleOptionsKeys,
  MACAR: macarKeys,
} as const
